// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottom":"assessor-file-upload__bottom--2evVF"};